import { Users, User, ExternalLink, BookOpen, ListTodo, Gift, Plane, Calendar } from '../../icons';
import { TYPE_COLOR_MAP, type CalendarEventType } from '../../api/calendar';

/**
 * 캘린더 카테고리 메타(2026-06-07) — type → SVG 아이콘 매핑 SSOT.
 *
 * 색상은 api/calendar.ts TYPE_COLOR_MAP(카테고리별 구분색), 아이콘은 본 모듈.
 * "아이콘화 가능한 텍스트 전부 SVG" 정책: 범례/팝업/월뷰 칩·바/상세에서 라벨 옆 아이콘 노출.
 * 이모지 금지 — lucide SVG 만([[feedback-no-emoji-use-svg]]).
 */
type IconCmp = typeof Calendar;

export const TYPE_ICON: Record<CalendarEventType, IconCmp> = {
  meeting: Users,        // 회의
  personal: User,        // 개인
  external: ExternalLink,// 외부
  training: BookOpen,    // 교육
  todo: ListTodo,        // 할일
  anniversary: Gift,     // 기념일
  vacation: Plane,       // 휴가
};

export function typeMeta(type: string): { label: string; color: string; Icon: IconCmp } {
  const t = type as CalendarEventType;
  const cm = TYPE_COLOR_MAP[t];
  return {
    label: cm?.label ?? type,
    color: cm?.color ?? 'var(--text-muted)',
    Icon: TYPE_ICON[t] ?? Calendar,
  };
}

/** 카테고리 아이콘 1개 렌더(라벨 옆/칩 내부 공용). */
export function TypeIcon({ type, size = 13 }: { type: string; size?: number }): JSX.Element {
  const { Icon } = typeMeta(type);
  return <Icon size={size} aria-hidden />;
}
